import React, { useEffect, useState } from 'react'
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Chip } from '@mui/material'
import Heatmap from 'react-heatmap-grid'
import { Button } from 'src/Common/ui/button'
import * as RiskTypes from 'src/Entities/RiskTypes'
import SaveCancelButton from 'src/Common/ui/SaveCancelButton'

const HeatMapDialog = ({
    open, handleClose, initialRiskScore, setinitialRiskScore, heatMapSelection, edit, type = 'RISK'
}) => {
    const [ selectedBox, setSelectedBox ] = useState(null)
    const [ riskValue, setRiskValue ] = useState({ impact: initialRiskScore?.impact, impactOfRisk: initialRiskScore?.impactOfRisk, Probability: initialRiskScore?.Probability, RiskScore: initialRiskScore?.RiskScore })
    useEffect(() => {
        setRiskValue({
            ...riskValue,
            impact: initialRiskScore?.impact,
            impactOfRisk: initialRiskScore?.impactOfRisk,
            Probability: initialRiskScore?.Probability,
            RiskScore: initialRiskScore?.RiskScore
        })
    }, [initialRiskScore])

    const handleThreeCrossBoxClick = (x, y) => {
        const RiskScore = RiskTypes.RISK_SCROING_DATA_THREE_CROSS[y][x]?.value
        const impact = x > 0 ? RiskTypes.RISK_SCROING_DATA_THREE_CROSS[y][0]?.value : RiskScore
        const Probability = y < RiskTypes.RISK_SCROING_DATA_THREE_CROSS.length - 1 ? RiskTypes.RISK_SCROING_DATA_THREE_CROSS[RiskTypes.RISK_SCROING_DATA_THREE_CROSS.length - 1][x]?.value : RiskScore

        setRiskValue({
            ...riskValue,
            impact: `${RiskTypes.Y_LABLES_THREE_CROSS[RiskTypes.IMPACT_VALUE_THREE_CROSS.indexOf(impact)]}`,
            Probability: `${RiskTypes.X_LABLES_THREE_CROSS[RiskTypes.PROBABILITY_VALUE_THREE_CROSS.indexOf(Probability)]}`,
            RiskScore: `${(RiskScore === RiskTypes.RISK_SCORE_ONE || RiskScore === RiskTypes.RISK_SCORE_TWO) ? RiskTypes.RISK_LEVEL_LOW : (RiskScore === RiskTypes.RISK_SCORE_THREE || RiskScore === RiskTypes.RISK_SCORE_FOUR) ? RiskTypes.RISK_LEVEL_MEDIUM : (RiskScore === RiskTypes.RISK_SCORE_SIX || RiskScore === RiskTypes.RISK_SCORE_NINE) && RiskTypes.RISK_LEVEL_EXTREME}`
        })
    }

    const chipColorStyle = riskScoreValue => {
        let textColor = 'hsl(var(--foreground))'
        if (riskScoreValue === 'Controlled') {
            textColor = 'hsl(var(--Controlled))'
        } else if (riskScoreValue === 'Low') {
            textColor = 'hsl(var(--Low))'
        } else if (riskScoreValue === 'Medium') {
            textColor = 'hsl(var(--Medium))'
        } else if (riskScoreValue === 'High') {
            textColor = 'hsl(var(--High))'
        } else if (riskScoreValue === 'Extreme') {
            textColor = 'hsl(var(--Extreme))'
        }
        return textColor
    }

    const handleBoxClick = (x, y) => {
        const RiskScore = RiskTypes.RISK_SCROING_DATA[y][x]?.value
        const impact = x > 0 ? RiskTypes.RISK_SCROING_DATA[y][0]?.value : RiskScore
        const Probability = y < RiskTypes.RISK_SCROING_DATA.length - 1 ? RiskTypes.RISK_SCROING_DATA[RiskTypes.RISK_SCROING_DATA.length - 1][x]?.value : RiskScore

        setRiskValue({
            ...riskValue,
            impact: `${RiskTypes.yLabels[RiskTypes.IMPACT_VALUE.indexOf(impact)]}`,
            Probability: `${RiskTypes.xLabels[RiskTypes.PROBABILITY_VALUE.indexOf(Probability)]}`,
            RiskScore: `${(RiskScore === RiskTypes.RISK_SCORE_ONE || RiskScore === RiskTypes.RISK_SCORE_TWO) ? RiskTypes.RISK_LEVEL_CONTROLLED : (RiskScore === RiskTypes.RISK_SCORE_THREE || RiskScore === RiskTypes.RISK_SCORE_FOUR || RiskScore === RiskTypes.RISK_SCORE_FIVE || RiskScore === RiskTypes.RISK_SCORE_SIX) ? RiskTypes.RISK_LEVEL_LOW : (RiskScore === RiskTypes.RISK_SCORE_EIGHT || RiskScore === RiskTypes.RISK_SCORE_NINE) ? RiskTypes.RISK_LEVEL_MEDIUM : (RiskScore === RiskTypes.RISK_SCORE_TEN || RiskScore === RiskTypes.RISK_SCORE_TWELVE || RiskScore === RiskTypes.RISK_SCORE_FIFTEEN || RiskScore === RiskTypes.RISK_SCORE_SIXTEEN) ? RiskTypes.RISK_LEVEL_HIGH : (RiskScore === RiskTypes.RISK_SCORE_TWENTY || RiskScore === RiskTypes.RISK_SCORE_TWENTY_FIVE) && RiskTypes.RISK_LEVEL_EXTREME}`
        })

    }

    const handleSave = () => {
        setinitialRiskScore(riskValue)
        handleClose()
    }
    return (
        <Dialog
            maxWidth="md"
            open={open}
            onClose={handleClose}
        >
            <Box >
                <DialogTitle sx={{ padding: '0px 10px 0px 10px', display: 'flex', alignItems: 'center', backgroundColor: 'hsl(var(--primary))', flexDirection: 'row', height: '40px', justifyContent: 'center' }}>
                    <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#fff' }}>{type === 'RISK' ? 'Choose Risk Score' : 'Choose Issue Score'}</div>
                </DialogTitle>
                <DialogContent>
                    <div style={{ height: '100%', display: 'flex', flexDirection: 'row' }}>
                        <div style={{ width: '45%' }}>
                            <div style={{ height: '90%', display: 'flex', flexDirection: 'row' }}>
                                <img src='/Assets/Impact.svg' style={{ height: '260px', marginTop: '3rem' }} alt="Impact" />
                                <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                    {heatMapSelection
                                        ? <Heatmap
                                            xLabels={RiskTypes.xLabels?.map((dt, indedx) => <p key={indedx} style={{ fontSize: '10px' }} >{dt}</p>)}
                                            yLabels={RiskTypes.yLabels.map((dt, indedx) => <p key={indedx} style={{ fontSize: '10px', marginLeft: '-50px' }} >{dt}</p>)}
                                            xLabelsLocation={'bottom'}
                                            xLabelWidth={50}
                                            data={RiskTypes.RISK_SCROING_DATA}
                                            squares
                                            height={45}
                                            onClick={(x, y) => {
                                                edit && handleBoxClick(x, y)
                                                edit && setSelectedBox({ x, y })
                                            }}
                                            cellStyle={(background, value, min, max, data, x, y) => ({
                                                fontSize: '12.5px',
                                                backgroundColor: value?.color,
                                                color: '#fff',
                                                border: selectedBox && selectedBox.x === x && selectedBox.y === y ? '7px solid #ffffff6e' : 'none'
                                            })}
                                        // cellRender={value => value && <div>{value.value}</div>}
                                        />
                                        : <Heatmap
                                            xLabels={RiskTypes.X_LABLES_THREE_CROSS?.map((dt, indedx) => <p key={indedx} style={{ fontSize: '10px' }} >{dt}</p>)}
                                            yLabels={RiskTypes.Y_LABLES_THREE_CROSS?.map((dt, indedx) => <p key={indedx} style={{ fontSize: '10px', marginLeft: '-50px' }} >{dt}</p>)}
                                            xLabelsLocation={'bottom'}
                                            xLabelWidth={50}
                                            data={RiskTypes.RISK_SCROING_DATA_THREE_CROSS}
                                            squares
                                            height={45}
                                            onClick={(x, y) => {
                                                edit && handleThreeCrossBoxClick(x, y)
                                                edit && setSelectedBox({ x, y })
                                            }}
                                            cellStyle={(background, value, min, max, data, x, y) => ({
                                                fontSize: '12.5px',
                                                backgroundColor: value?.color,
                                                color: '#fff',
                                                border: selectedBox && selectedBox.x === x && selectedBox.y === y ? '7px solid #ffffff6e' : 'none'
                                            })}
                                        />}
                                </div>
                            </div>
                            <img src='/Assets/Probability.svg' style={{ paddingLeft: '60px', marginLeft: '6px' }} alt="Impact" />
                        </div>
                        <span style={{
                            display: 'inline-block',
                            width: '2px',
                            backgroundColor: 'hsl(var(--primary-foreground))',
                            margin: ' 0 10px',
                            height: ' 22em'
                        }} />
                        <div style={{ width: '40%', marginLeft: '1rem', marginTop: '2rem', display: 'flex', flexDirection: 'column' }}>
                            <div className='mb-1' >
                                <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '3.5rem', justifyContent: 'center', alignItems: 'center', fontSize: '13px' }}>
                                    <p style={{ fontWeight: 'bold', width: '4.5rem', marginRight: '1rem', fontSize: '12px' }}>Risk Level</p>
                                    {heatMapSelection
                                        ? RiskTypes.RISK_RATINNG?.map((data, ind) => {
                                            return (
                                                <div style={{ width: 65, border: '0.5px solid black', color: '#fff', textAlign: 'center', backgroundColor: data?.color, fontSize: '12px' }} key={ind} >{data?.title}</div>
                                            )
                                        })
                                        : RiskTypes.RISK_RATINNG_THREE_CROSS?.map((data, ind) => {
                                            return (
                                                <div style={{ width: 65, border: '0.5px solid black', color: '#fff', textAlign: 'center', backgroundColor: data?.color, fontSize: '12px' }} key={ind} >{data?.title}</div>
                                            )
                                        })
                                    }
                                </div>
                                <div className="max-w-30 mb-7 block font-medium">
                                    <h4 style={{ display: 'inline-block', marginRight: '0.2rem', color: 'hsl(var(--primary))' }}>
                                        Impact :
                                    </h4>
                                    <span>
                                        {riskValue?.impact || ''}
                                    </span>
                                </div>
                                <div className="max-w-30 mb-7 font-medium">
                                    <h4 style={{ display: 'inline-block', marginRight: '0.2rem', color: 'hsl(var(--primary))' }}>
                                    Probability :
                                    </h4>
                                    <span>
                                        {riskValue?.Probability || ''}
                                    </span>
                                </div>
                                <div className=" max-w-30 mb-7 font-medium">
                                    <h4 style={{ display: 'inline-block', marginRight: '0.2rem', color: 'hsl(var(--primary))' }}>
                                    Risk Level :
                                    </h4>
                                    <span>
                                        <Chip
                                            key={riskValue?.RiskScore || ''}
                                            label={riskValue?.RiskScore || ''}
                                            sx={{
                                                width: '100px',
                                                color: 'hsl(var(--foreground))',
                                                backgroundColor: chipColorStyle(riskValue?.RiskScore)
                                            }}

                                        />
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </DialogContent>

                {edit
                    ? <DialogActions style={{ width: '100%', display: 'flex', padding: '15px 30px 15px 30px', flexDirection: 'row', justifyContent: 'flex-end' }}>

                        <div className='d-flex content-end'>
                            <SaveCancelButton handleCancel={handleClose} handleSave={handleSave} />
                        </div>
                    </DialogActions>
                    : <DialogActions>
                        <Button
                            variant='outline'
                            style={{ color: 'hsl(var(--destructive))', borderColor: 'hsl(var(--destructive))' }}
                            onClick={handleClose}
                        >
                    Cancel
                        </Button>
                    </DialogActions>
                }
            </Box>
        </Dialog>
    )
}

export default HeatMapDialog
